// utilities
import api from '@/utilities/api'
export const getBlackoutTypes = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/blackouts/types',
    success (response) {
      commit('setBlackoutTypes', response.data)
    }
  })
}
// campsite
export const getCampsiteBlackouts = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/blackouts/campsites',
    payload,
    success (response) {
      commit('setCampsiteBlackouts', response.data)
    }
  })
}
export const createCampsiteBlackout = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/blackouts/campsites',
    payload,
    success (response) {
      dispatch('getCampsiteBlackouts')
    }
  })
}
export const deleteCampsiteBlackout = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/blackouts/campsites/' + payload.campsiteBlackoutID,
    payload,
    success (response) {
      dispatch('getCampsiteBlackouts')
    }
  })
}
// parking
export const getParkingBlackouts = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/blackouts/parking',
    payload,
    success (response) {
      commit('setParkingBlackouts', response.data)
    }
  })
}
export const createParkingBlackout = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'post',
    endpoint: 'private/blackouts/parking',
    payload,
    success (response) {
      dispatch('getParkingBlackouts')
    }
  })
}
export const deleteParkingBlackout = ({ commit, dispatch }, payload) => {
  return api.request({
    method: 'delete',
    endpoint: 'private/blackouts/parking/' + payload.parkingBlackoutID,
    payload,
    success (response) {
      dispatch('getParkingBlackouts')
    }
  })
}
